import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  Button,
  TabContent,
  Input,
  TabPane,
  Modal, ModalBody,
  NavItem, ModalHeader,
  CardHeader, ModalFooter,
  Nav,
} from 'reactstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getGroupID, AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import '../../style/style.css';
import { post_API_Send_Email, putAPI_Delete_Image, deleteAPI_Preview_Password } from '../../../../../../constants/APIs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import UploadImage from '../UploadImage';

export default function HelpCenterCodeSnippet({ integration, propertyId, saveIntegration, service }) {
  const [value, setValue] = useState('');
  const [iframevalue, setIframeValue] = useState('');
  const [copied, setCopied] = useState(false);
  const [iframecopied, setIframeCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('standard');
  const [showEmailBox, setShowEmailBox] = useState(false);
  const [developerEmail, setDeveloperEmail] = useState('');
  const [isUpload, setIsUpload] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [previewPassword, setPreviewPassword] = useState("");
  const [IsPreviewPassword, setExistPreviewPassword] = useState(false);
  const [error, setError] = useState("");
  const domain = (service !== null && service !== undefined && service !== ""
    ? `https://messenger.${service}`
    : process.env.REACT_APP_MESSENGER_URL);

  const preview_demo = (
    service !== null && service !== undefined && !service.includes("myma.ai"))
    ? `https://preview.${service}/messenger-preview`
    : process.env.REACT_APP_MESSENGER_DEMO;


  const preview_personalized = (service !== null && service !== undefined && !service.includes("myma.ai"))
    ? `https://preview.${service}/messenger-preview-personalized`
    : process.env.REACT_APP_MESSENGER_PREVIEW_PERSONALIZED;

  useEffect(() => {
    if (integration !== undefined && integration.botSettings !== undefined && integration.botSettings.previewImages !== null) {
      const previewImages = integration.botSettings.previewImages;
      //console.log(previewImages);
      setPreviewImage({
        ...previewImage,
        id: previewImages.id,
        imageLink: previewImages.imageLink,
        previewPassword: previewImages.previewPassword,
      })

    }
    const savedPassword = integration.botSettings.previewImages.previewPassword;
    if (savedPassword) {
      setPreviewPassword(savedPassword);
      setExistPreviewPassword(true);
    }
    else {
      setExistPreviewPassword(false);
    }
    console.log('domgrp', domain, preview_demo);
    const gid = getGroupID();
    const iid = integration.id;
    const text = `<!-- This is start of the Website AI Chatbot Widget code -->
      <script>
      var BMB_MESSENGER_domain = '${domain}/';
      var BMB_messengerHTMLPath = BMB_MESSENGER_domain + 'index.html'; 
      var BMB_MESSENGER_head = document.getElementsByTagName('head')[0];
      var BMB_MESSENGER_script = document.createElement('script');  
      BMB_MESSENGER_script.type = 'text/javascript';
      BMB_MESSENGER_script.src = BMB_MESSENGER_domain + 'msgplugin.js';
      BMB_MESSENGER_head.appendChild(BMB_MESSENGER_script);
      var BMB_MESSENGER_gid = '${gid}';
      var BMB_MESSENGER_iid = '${iid}';
      var BMB_MESSENGER_pid = '';
    </script>
  <!-- This is end of the Website AI Chatbot Widget code  -->`;
    setValue(text);
    const iframetext = `<iframe frameborder="0" style="bottom: 0; right: 0; margin: 0; z-index: 2000001;height:630px;width:390px;" id="messengeriframe" src="${domain}?location=&amp;title=&amp;referrer=&amp;iid=${iid}&amp;gid=${gid}&amp;mobile=false&amp;open=1&custom=1"></iframe>`;
    setIframeValue(iframetext);
  }, []);

  const RedirectToDemo = () => {
    var url = `${preview_demo}?gid=${getGroupID()}&iid=${integration.id
      }`;
    window.open(url, '_blank');
  };
  const RedirectToPersonalizedPreview = () => {
    var url = `${preview_personalized}?gid=${getGroupID()}&iid=${integration.id}`;
    window.open(url, '_blank');
  }
  const RedirectToIframeDemo = () => {
    // var url = `${process.env.REACT_APP_BOT_IFRAME_DEMO
    //   }?gid=${getGroupID()}&iid=${integration.id}`;
    // window.open(url, '_blank');
  };

  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const SendEmail = () => {

    let data = {
      'groupId': getGroupID(), intregationId: integration.id,
      'Email': developerEmail, 'propertyId': propertyId
    };
    AxiosAPI({
      method: 'post',
      url: `${post_API_Send_Email}`,
      data,
    })
  };

  const GetUploadedImage = (url) => {
    setPreviewImage(url);
    const botSetting = integration.botSettings;
    botSetting.previewImages = url;
    saveIntegration({ botSetting: botSetting });
  }
  const savePreviewPassword = () => {
    if (previewPassword.length < 6 && previewPassword.trim() !== "") {
      setError("Minimum 6 characters required");
      return;
    } else {
      const botSetting = { ...integration.botSettings };
      const previewpass = { ...(botSetting.previewImages || {}) };
      if (previewPassword && previewPassword.trim() !== "") {
        previewpass.previewPassword = previewPassword;
        botSetting.previewImages = previewpass;
        saveIntegration({ botSetting: botSetting });
        setExistPreviewPassword(true);
        setError("");
      }
      else {
        delete previewpass.previewPassword;
        setError("Minimum 6 characters required");
        return;
      }
    }
  }
  const DeletePreviewPassword = () => {
    AxiosAPI({
      method: 'delete',
      url: `${deleteAPI_Preview_Password}/${integration.id
        }?group_id=${getGroupID()}`,
    })
      .then(() => {
        NotificationManager.success(
          '',
          'Preview password removed successfully.',
          3000,
          null,
          null,
          'success'
        );
        setExistPreviewPassword(false);
        setPreviewPassword('');
      })
  }
  const handleDelete = () => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Image}/${previewImage.id}`,
      data: {
        deleter: 'dashboard'
      },
    })
      .then(res => {
        toggle();
        var previewbody = {
          ...previewImage,
          id: "00000000-0000-0000-0000-000000000000",
          imageLink: ""
        };
        setPreviewImage(previewbody);
        const botSetting = integration.botSettings;
        botSetting.previewImages = previewbody;
        saveIntegration({ botSetting: botSetting });
      })
      .catch(err => {
        console.log(err);
      });
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This image will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    <IntlMessages id='dashboards.delete' />
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    <IntlMessages id='pages.cancel' />
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody className="mt-1">
          <Nav tabs className="separator-tabs ml-0 mr-0 ">
            <NavItem className="w-50 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'standard',
                  'nav-link': true,
                })}
                onClick={() => toggleAppMenu('standard')}
              >
                Standard
              </NavLink>
            </NavItem>
            <NavItem className="w-50 text-center">
              <NavLink
                style={{ marginRight: "0px" }}
                to="#"
                location={{}}
                className={classnames({
                  active: activeTab === 'embed',
                  'nav-link': true,
                })}
                onClick={() => toggleAppMenu('embed')}
              >
                Embed
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="standard" className="chat-app-tab-pane" style={{ background: "none" }}>
              <Card className="m-4">
                <CardBody>
                  <h6 className="text-center">Publish your Web Widget</h6>
                  <p className='text-center mb-2' >Follow the instructions to start displaying the Web Widget on your website. Once it’s added, you can adjust the design, positioning, and other settings at any time without modifying the code.</p>
                  <Separator className="mb-3" />
                  <div className="code-snippet">
                    <span>
                      {' '}
                      &lt;&#33;&#45;&#45; This is start of the Website AI Chatbot Widget code  &#45;&#45;&gt;
                    </span>
                    <span>&lt;script&gt;</span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_domain = '{domain}/';
                      {/* '{process.env.REACT_APP_MESSENGER_URL}/'; */}
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_messengerHTMLPath =
                      BMB_MESSENGER_domain + 'index.html';
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_head =
                      document.getElementsByTagName('head')[0];
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_script =
                      document.createElement('script');
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;BMB_MESSENGER_script.type =
                      'text/javascript';
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;BMB_MESSENGER_script.src = BMB_MESSENGER_domain +
                      'msgplugin.js';
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;BMB_MESSENGER_head.appendChild(BMB_MESSENGER_script);
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_gid = '{getGroupID()}';
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_iid = '{integration.id}';
                    </span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;var BMB_MESSENGER_pid = '';</span>
                    <span>&lt;/script&gt;</span>
                    <span>
                      {' '}
                      &lt;&#33;&#45;&#45;This is end of the Website AI Chatbot Widget code
                      &#45;&#45;&gt;{' '}
                    </span>
                  </div>

                  <div className="text-center mb-3">
                    <b>
                      Copy and paste this code just before the closing &lt;/body&gt; tag on every page of your website, or add it through Google Tag Manager (GTM).
                    </b>
                  </div>
                  <Separator className="mb-3" />
                  <div className="d-flex justify-content-center">
                    <div>
                      <Button
                        color="success"
                        className='my-2'
                        size="xs"
                        onClick={() => setShowEmailBox(!showEmailBox)}
                      >
                        Email to developer
                      </Button>
                    </div>
                    <div>
                      <Button
                        color="success"
                        size="xs"
                        className='my-2 mx-2'
                        onClick={RedirectToDemo}
                      >
                        Preview
                      </Button>
                    </div>
                    <div>
                      <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
                        <Button
                          color="success"
                          size="xs"
                          className='my-2'
                        >
                          Copy the code snippet
                        </Button>
                      </CopyToClipboard>
                      {copied ? <h6 className='text-center'>Copied</h6> : null}
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card className="m-4">
                <CardBody>
                  <div className="text-center mb-2">
                    <p>Personalize your preview by adding your website as the background<br />
                      Take a screenshot of your website homepage and load her.</p>
                  </div>
                  <Separator className="mb-3" />
                  {previewImage !== null && previewImage.imageLink !== null && (
                    <>
                      <div className='my-2 text-center'>
                        <img style={{ width: "10rem", height: "10rem" }} src={previewImage.imageLink}></img>
                      </div>
                      <Separator className="mb-3" />
                    </>
                  )}
                  <div className='text-center'>
                    <Button
                      color="success"
                      className='my-2'
                      size="xs"
                      onClick={() => setIsUpload(!isUpload)}
                    >
                      Upload Image
                    </Button>
                    {previewImage !== null && previewImage.imageLink !== null && (
                      <Fragment>
                        <Button
                          color="success"
                          size="xs"
                          className='m-2'
                          onClick={RedirectToPersonalizedPreview}
                        >
                          Preview
                        </Button>
                        <Button
                          color="danger"
                          size="xs" className='my-2'
                          onClick={toggle}
                        >
                          Delete
                        </Button>
                      </Fragment>
                    )}
                  </div>
                </CardBody>
              </Card>
              <Card className="m-4">
                <CardBody>
                  <div className='text-center'>
                    <p>Secure the Preview Page with a password (minimum 6 characters)</p>
                  </div>
                  <div className="my-2">
                    <Input
                      value={previewPassword}
                      minLength={6}   // at least 6 chars
                      onChange={(e) => setPreviewPassword(e.target.value)}
                      placeholder="Choose password"
                      style={{ maxWidth: '300px', margin: '0 auto' }}
                    />
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </div>
                  <Separator className="my-3" />
                  <div className='text-center'>
                    <Button
                      color="primary"
                      className='mr-1'
                      size="xs"
                      className='my-2'
                      onClick={savePreviewPassword}
                    >
                      Save
                    </Button>
                    {IsPreviewPassword && (
                      <Button
                        color="danger"
                        size="xs"
                        className='my-2 ml-2'
                        onClick={DeletePreviewPassword}
                      >
                        Delete
                      </Button>
                    )}
                  </div>
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId="embed" className="chat-app-tab-pane" style={{ background: "none" }}>
              <Card className="m-4">
                <CardBody>
                  <h6 className="text-center">Embed your Assistant</h6>
                  <Separator className="mb-3" />
                  <div className="code-snippet">
                    <span>
                      &lt;iframe frameborder="0" style="bottom: 0; right: 0; margin:
                      0; z-index: 2000001;height:630px;width:390px;"
                      id="messengeriframe"
                      src="{domain}?location=&amp;title=&amp;referrer=&amp;iid=
                      {integration.id}&amp;gid={getGroupID()}
                      &amp;mobile=false&amp;open=1&custom=1"&gt;&lt;/iframe&gt;
                    </span>
                  </div>
                  <div className="text-center">
                    <div className="text-center mb-3">
                      <b>
                        Copy and paste this code at desired location on the page of
                        your website.
                      </b>
                    </div>
                    <Separator className="mb-3" />
                    <div>
                      <CopyToClipboard text={iframevalue} onCopy={() => setIframeCopied(true)}>
                        <Button
                          color="success"
                          size="xs"
                          className='my-2'
                        >
                          Copy the code snippet
                        </Button>
                      </CopyToClipboard>
                      {iframecopied ? <h6 className='text-center'>Copied</h6> : null}
                    </div>
                    {/* <div>
                      <Button
                        color="success"
                        size="xs"
                        className='my-2 ml-2'
                        onClick={RedirectToIframeDemo}
                      >
                        Preview
                      </Button>
                    </div> */}
                  </div>
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>

      <Modal className='intregation-modal-content' style={{ borderRadius: '10px' }} isOpen={showEmailBox} toggle={() => setShowEmailBox(!showEmailBox)}>
        <ModalHeader toggle={() => setShowEmailBox(!showEmailBox)}>
          Your developer`s e-mail address:
        </ModalHeader>
        <ModalBody>
          <Card className='p-4'>
            <p> Your developer teammate will receive an e-mail containing the code and necessary instructions to implement it.
            </p>
            <p>
              <Input
                className='mt-2'
                style={{ borderRadius: '10px' }}
                type="text"
                name="email"
                value={developerEmail}
                placeholder="E-mail"
                onChange={(e) => setDeveloperEmail(e.target.value)}
              />
            </p>
          </Card>
        </ModalBody>
        <ModalFooter className='text-center'>
          <Button
            color="success"
            size="xs"
            onClick={() => { SendEmail(); setDeveloperEmail(''); setShowEmailBox(!showEmailBox); }}
          >
            <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>
            <span className='ml-2' >Send</span>
          </Button>
        </ModalFooter>
      </Modal>
      {isUpload &&
        <UploadImage
          GetUploadedImage={GetUploadedImage}
          botsetting={integration.botSettings}
          visible={isUpload}
          toggle={() => setIsUpload(!isUpload)}
          propertyId={propertyId}
        ></UploadImage>
      }
      {generateDeleteButton()}
    </Fragment>
  );
}
